import React, { useEffect } from "react";
import PageHeader from "../components/PageHeader";

const Qualita: React.FC = () => {
  useEffect(() => {
    document.title = "CO.ME.ST. S.R.L - Qualità e Certificazioni";
  }, []);

  return (
    <div className="bg-white">
      <PageHeader title="Qualità e Certificazioni" breadcrumb="Qualità" />

      <div className="container px-4 py-16 mx-auto sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          {/* Introduction */}
          <header className="mb-16 text-center">
            <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
              Il Nostro Impegno per l'Eccellenza
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-xl text-gray-600">
              La qualità non è solo un obiettivo, ma il fondamento del nostro
              processo produttivo. Le nostre certificazioni testimoniano
              l'impegno costante nel fornire prodotti e servizi che superano le
              aspettative.
            </p>
          </header>

          <div className="grid gap-10 mb-12 md:grid-cols-2">
            <div className="p-8 bg-gray-100 rounded-2xl">
              <h3 className="mb-4 text-2xl font-bold text-gray-800">
                Hardware di Precisione
              </h3>
              <p className="text-lg leading-relaxed text-gray-700">
                Il nostro impegno per la qualità si traduce in un controllo
                meticoloso in ogni fase. Per la validazione dimensionale, ci
                avvaliamo dello <strong>scanner 3D Leonardo</strong> per
                assicurare una precisione assoluta e della macchina di misura
                <strong> CTR DEA Scirocco</strong> per report dimensionali
                certificati. A queste si aggiunge la macchina{" "}
                <strong>Metro Com</strong> per le prove di compressione e
                strappo.
              </p>
            </div>
            <div className="p-8 bg-gray-100 rounded-2xl">
              <h3 className="mb-4 text-2xl font-bold text-gray-800">
                Software Leader di Settore
              </h3>
              <p className="text-lg leading-relaxed text-gray-700">
                Il nostro flusso di lavoro è potenziato da software
                all'avanguardia. Utilizziamo <strong>PolyWorks</strong>, la
                piattaforma universale per la metrologia 3D, per processare dati
                ed effettuare analisi approfondite. Per la programmazione CMM,
                ci affidiamo a <strong>CAPPS DMIS</strong>, uno standard
                industriale che garantisce precisione e compatibilità.
              </p>
            </div>
          </div>

          <video
            className="mb-12 w-full h-auto rounded-2xl shadow-2xl"
            src="/video/scansione.mp4"
            autoPlay
            loop
            muted
            playsInline
          >
            Your browser does not support the video tag.
          </video>

          {/* Certifications Section */}
          <div className="space-y-12">
            {/* IATF 16949:2016 */}
            <div className="p-8 bg-gray-50 rounded-2xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center w-12 h-12 text-2xl bg-[#3b5998] rounded-full text-white">
                  ✓
                </div>
                <h2 className="ml-4 text-3xl font-bold text-gray-800">
                  IATF 16949:2016
                </h2>
              </div>
              <p className="mb-6 text-lg text-gray-700">
                Specifica per il settore automotive, questa certificazione
                sottolinea il nostro impegno nella prevenzione dei difetti e
                nella riduzione della variabilità e degli sprechi nella catena
                di fornitura. È la garanzia di un partner affidabile che opera
                secondo i più rigorosi standard internazionali del settore.
              </p>
              <div className="flex flex-col items-start space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
                <a
                  href="/cert/CERT-IATF-21410-ITA.pdf"
                  download
                  className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-white bg-[#3b5998] border border-transparent rounded-md shadow-sm hover:bg-opacity-90"
                >
                  Download (Italiano)
                </a>
                <a
                  href="/cert/CERT-IATF-21410-ENG.pdf"
                  download
                  className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-[#3b5998] bg-blue-100 border border-transparent rounded-md hover:bg-blue-200"
                >
                  Download (English)
                </a>
              </div>
            </div>

            {/* ISO 9001:2015 */}
            <div className="p-8 bg-gray-50 rounded-2xl shadow-lg">
              <div className="flex items-center mb-4">
                <div className="flex items-center justify-center w-12 h-12 text-2xl bg-[#3b5998] rounded-full text-white">
                  ✓
                </div>

                <h2 className="ml-4 text-3xl font-bold text-gray-800">
                  ISO 9001:2015
                </h2>
              </div>
              <p className="text-lg text-gray-700">
                Questa certificazione dimostra la nostra capacità di fornire con
                regolarità prodotti e servizi che soddisfano i requisiti dei
                clienti e quelli cogenti applicabili. Ci impegniamo ad
                accrescere la soddisfazione dei nostri clienti tramite
                l'applicazione efficace del sistema, compresi i processi per il
                miglioramento continuo.
              </p>
              <div className="flex flex-col items-start mt-6 space-y-4 sm:flex-row sm:space-y-0 sm:space-x-4">
                <a
                  href="/cert/CERT-ISO9001-21410-ITA-2025-01-30.pdf"
                  download
                  className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-white bg-[#3b5998] border border-transparent rounded-md shadow-sm hover:bg-opacity-90"
                >
                  Download (Italiano)
                </a>
                <a
                  href="/cert/CERT-ISO9001-21410-ENG-2025-01-30.pdf"
                  download
                  className="inline-flex items-center justify-center px-6 py-3 text-base font-medium text-[#3b5998] bg-blue-100 border border-transparent rounded-md hover:bg-blue-200"
                >
                  Download (English)
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Qualita;
